export default __webpack_public_path__ + "static/media/snapchat_icon.ff41739a.png";